import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,

    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Gipszkartonozás</Title>
        <p>
          A gipszkarton az úgynevezett szárazépítési technológia anyaga, tehát azért szeretik sokan, mert víz nélkül,
          egyszerű szerelési munkával készíthetünk falat, álmennyezetet, sőt akár beépített polcot is.
          Gipszkartonozással kreatív formai gazdagságot, modernséget, egyediséget csempészhetünk a lakásba. A sík falak
          térbeli megtörésével, rejtett világítás beépítésével megváltozhat lakásod hangulata. A szerkezet kis súlya
          miatt olyan helyekre is felépíthető, ahova más szerkezetet nem lehet, vagy csak igen nagy költséggel. Kötetlen
          tervezhetőség. Nincs modulméret, ezért nincsenek méretmegkötések. Gipszkartonozással íves falak és nyílások
          egyszerűen kialakíthatók, így különböző, egyedi stílusú falakat is kitalálhatunk magunknak. A fémvázas
          kialakítású falszerkezetben tűzvédelmi, illetve hang és hőszigetelés helyezhető el. A helyiségek
          rendeltetésszerű használatához szükséges gépész és elektromos alapvezetékeket szintén el lehet helyezni. A
          gipszkarton éghetetlen, gipszmagja jó tűzvédelmi tulajdonságú. A kis önsúly egyszerűbb, olcsóbb szerkezetek
          alkalmazására ad lehetőséget. A gipszkarton rendszer jó hangszigetelő képességgel rendelkezik, mely sokrétű
          felhasználást tesz lehetővé. Vizes helységekben is lehetőség van gipszkartonozásra, itt a felhasználandó
          gipszkartonnak impregnált felületkezelésűnek kell lennie (zöld színű), erős víztaszító, lepergető hatású. A
          felújítások során pedig az egyik leghálásabb dolog a gipszkartonozás tiszta. Szinte minden lakásban található
          televízió, hangfalak, lámpák, töltők, monitorok, laptopok stb. A gipszkarton kiválóan használható arra, hogy
          elrejtsük a vezetékek látványát vagy pedig falvésés és fúrás nélkül vezessünk el kábeleket. A gipszkarton
          kiválóan klimatizál, ami igen előnyös a fokozott záródású ablakok és ajtók korában. A gipszkarton képes
          szabályozni a levegő páratartalmát, mivel a gipszmag pórusai egy ideig magukban tartják a nedvesebb levegőt, a
          száraz levegőbe pedig visszapárologtatják ezt a nedvességtartalmat.
        </p>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
